import { Inject } from 'vue-di-container';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Toaster } from '../../../Services/toast';
import UserModel from '../../../shared/userService/Model/UserModel';
import UserService from '../../../shared/userService/UserService';
import UserRoleService from '../../../shared/userService/UserRoleService';
import WithRender from './UpdateRequests.html';
import { UpdateRequestsFilterModel } from './UpdateRequestsFilterModel';
import { UpdateRequestsModel } from './UpdateRequestsModel';
import UpdateRequestsService from './UpdateRequestsService';
import { SenderType } from '../../../shared/Enums/SenderType';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        UpdateRequestsService,
        UserService,
        UserRoleService,
    ],
})
export default class UpdateRequests extends Vue {
    @Inject(UserService) public userService!: UserService;
    @Inject(UpdateRequestsService) public updateRequestsService!: UpdateRequestsService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;

    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;

    public filterModel: UpdateRequestsFilterModel = {
        clientName: '',
        senderName: '',
        displayId: '',
        status: 0,
    };
    public user: UserModel = {
        userId: '',
        username: '',
        details: {
            Email: '',
            TenantId: '',
            MobilePhone: '',
            Operator: '',
            Provider: '',
            OperatorId: '',
            ProviderId: '',
            Role: '',
            ChangePasswordRequired: '',
        },
    };
    public userRole: number = 0;
    public senders: UpdateRequestsModel[] = [];
    public sendersCount: number = 0;
    public User: any = null;
    public pagination: any = {
        sortBy: 'createdDate',
        descending: true,
    };
    public rejectDialog: boolean = false;
    public rejectReason: string = '';
    public rejectTargetId: string = '';
    public approveDialog: boolean = false;
    public approveTargetId: string = '';

    public statusOptions: any[] = [
        {
            id: 1,
            name: this.$t('dashboardPage.pendingFor').toString() + ' ' +
                this.$t('dashboardPage.approval').toString(),
        },
        { id: 2, name: this.$t('dashboardPage.approved').toString() },
        { id: 3, name: this.$t('dashboardPage.rejected').toString() },
    ];

    public headers: any = [];

    public get rejectReasonIsValid(): boolean {
        return this.rejectReason !== null && this.rejectReason.trim() !== '';
    }

    public changeSort(column: any) {
        const header = this.headers.find((h: any) => h.value === column);
        if (!header || !header.sortable) {
            return;
        }
        if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
        } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
        }
        this.updatePaginate(this.pagination);
    }

    public async mounted() {
        this.$emit('childinit', this.layoutSup);
        this.User = await this.userService.getUser();
        this.userRole = this.GetUserRole();
        this.buildHeaders();
        await this.search();
    }

    public buildHeaders() {
        this.headers = [
            {
                text: this.$t('updateDataRequestsPage.requestId'),
                sortable: false,
                value: 'displayId',
                align: 'center',
            },
            {
                text: this.$t('updateDataRequestsPage.clientName'),
                sortable: false,
                value: 'clientName',
                align: 'center',
            },
            {
                text: this.$t('updateDataRequestsPage.senderName'),
                sortable: false,
                value: 'senderName',
                align: 'center',
            },
            { text: this.$t('shared.senderType'), sortable: false, value: 'senderType', align: 'center' },
            {
                text: this.$t('updateDataRequestsPage.status'),
                sortable: true,
                value: 'requestStatus',
                align: 'center',
            },
            {
                text: this.$t('updateDataRequestsPage.requestDate'),
                sortable: true,
                value: 'createdDate',
                align: 'center',
            },
            { text: this.$t('shared.actions'), sortable: false, value: 'actions', align: 'center', width: '145' },
        ];
    }

    @Watch('filterModel', { deep: true })
    public async search() {
        if (this.filterModel.status === null || this.filterModel.status === undefined) {
            this.filterModel.status = 0;
            return;
        }
        await this.loadPage(0, 10);
    }

    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }

    public newRequest() {
        this.$router.push({ name: 'NewUpdateRequest' });
    }

    public viewDetails(id: string) {
        this.$router.push({ name: 'UpdateRequestDetails', params: { id } });
    }

    public fillSenderTypes(type: number): number[] {
        const types: number[] = [];
        if ((type & 1) === 1) { types.push(1); }
        if ((type & 2) === 2) { types.push(2); }
        if ((type & 4) === 4) { types.push(4); }
        if ((type & 8) === 8) { types.push(8); }
        return types;
    }

    public getSenderTypeText(typeId: number) {
        switch (typeId) {
            case SenderType.Advertisement:
                return this.$t('shared.advertisement').toString();
            case SenderType.Service:
                return this.$t('shared.service').toString();
            case SenderType.Awareness:
                return this.$t('shared.awareness').toString();
            case SenderType.Warning:
                return this.$t('shared.warning').toString();
            default:
                return '-';
        }
    }

    public showApproveDialog(id: string) {
        this.approveTargetId = id;
        this.approveDialog = true;
    }

    public hideApproveDialog() {
        this.approveDialog = false;
        this.approveTargetId = '';
    }

    public async confirmApprove() {
        const response = await this.updateRequestsService.Approve([this.approveTargetId], '');
        if (!response || !response.isSuccess) {
            Toaster.error((response && response.errorMessage) || this.$t('shared.errorOccurred').toString());
            return;
        }
        Toaster.success(this.$t('dashboardPage.RequestApprovedsuccessfully').toString());
        this.hideApproveDialog();
        await this.search();
    }

    public showRejectDialog(id: string) {
        this.rejectTargetId = id;
        this.rejectReason = '';
        this.rejectDialog = true;
    }

    public hideRejectDialog() {
        this.rejectDialog = false;
        this.rejectTargetId = '';
        this.rejectReason = '';
    }

    public async confirmReject() {
        if (!this.rejectReasonIsValid) {
            return;
        }
        const response = await this.updateRequestsService.Reject([this.rejectTargetId], this.rejectReason.trim());
        if (!response || !response.isSuccess) {
            Toaster.error((response && response.errorMessage) || this.$t('shared.errorOccurred').toString());
            return;
        }
        Toaster.success(this.$t('dashboardPage.RequestRejectedsuccessfully').toString());
        this.hideRejectDialog();
        await this.search();
    }

    public async updatePaginate(val: any) {
        const page = val && val.page ? val.page - 1 : 0;
        const rowsPerPage = val && val.rowsPerPage ? val.rowsPerPage : 10;
        await this.loadPage(page, rowsPerPage);
    }

    public async reload() {
        await this.search();
    }

    private async loadPage(pageIndex: number, pageSize: number) {
        const status = (this.filterModel.status === null || this.filterModel.status === undefined)
            ? 0
            : this.filterModel.status;
        const model = {
            clientName: this.filterModel.clientName,
            senderName: this.filterModel.senderName,
            displayId: this.filterModel.displayId,
            status,
            pageIndex: pageIndex.toString(),
            pageSize,
            sortBy: this.pagination.sortBy || 'createdDate',
            sortDirection: this.pagination.descending === true,
        };
        const response = await this.updateRequestsService.Get(model);
        if (response !== false) {
            if (!response.isSuccess) {
                Toaster.error(response.errorMessage);
            }
            this.senders = response.result || [];
            this.sendersCount = response.totalCount || 0;
        }
    }
}
